import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { applyPageMeta, resetPageMeta } from '../lib/pageMeta';

export default function ImpressumPage() {
  useEffect(() => {
    applyPageMeta({
      title: 'Impressum – Anbieterkennzeichnung',
      description: 'Anbieterkennzeichnung nach § 5 DDG und § 18 MStV für DSGVOeasy, das SaaS-Tool für Datenschutzmanagement von Matthias Donner Consulting.',
      path: '/impressum',
    });

    return resetPageMeta;
  }, []);

  return (
    <div style={{ fontFamily: "'72', '72full', Arial, Helvetica, sans-serif", color: '#32363a', minHeight: '100vh', background: '#f6f8fb' }}>
      {/* Nav */}
      <nav style={{
        background: 'white',
        borderBottom: '1px solid #e5e5e5',
      }}>
        <div className="legal-nav-inner" style={{
          maxWidth: '800px',
          margin: '0 auto',
          padding: '0 2rem',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          height: '3.5rem',
        }}>
          <Link to="/login" style={{ display: 'flex', alignItems: 'center', gap: '0.625rem', textDecoration: 'none' }}>
            <img src="/logo.png" alt="DSGVOeasy" style={{ height: '2rem', width: 'auto' }} />
            <span style={{ fontWeight: 700, fontSize: '1.125rem', color: '#1a1d21' }}>DSGVOeasy</span>
          </Link>
          <div className="legal-nav-links" style={{ display: 'flex', gap: '1.5rem' }}>
            <Link to="/datenschutz" style={{ color: '#556170', fontWeight: 600, fontSize: '0.875rem', textDecoration: 'none' }}>Datenschutz</Link>
            <Link to="/login" style={{ color: '#0070f2', fontWeight: 600, fontSize: '0.875rem', textDecoration: 'none' }}>Zurück</Link>
          </div>
        </div>
      </nav>

      <div className="legal-container" style={{ maxWidth: '860px', margin: '0 auto', padding: '3rem 2rem 5rem' }}>
        <div className="legal-card" style={{
          background: 'white',
          borderRadius: '1rem',
          padding: '3rem',
          boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
          border: '1px solid #edf0f4',
          lineHeight: 1.7,
          fontSize: '0.9375rem',
        }}>
          <h1 style={{ fontSize: '2rem', fontWeight: 700, marginBottom: '2rem', color: '#1a1d21' }}>Impressum</h1>

          <p>
            Matthias Donner<br />
            Matthias Donner Consulting<br />
            Fürstenfeldbrucker Str. 14<br />
            82272 Moorenweis
          </p>

          <h2 style={h2Style}>Kontakt</h2>
          <p>
            Telefon: 08141 315 930 0<br />
            E-Mail: team@matthiasdonner.com
          </p>

          <h2 style={h2Style}>Umsatzsteuer-ID</h2>
          <p>
            Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:<br />
            DE403281009
          </p>

          <h2 style={h2Style}>Angaben zur Berufshaftpflichtversicherung</h2>
          <p>
            <strong>Name und Sitz des Versicherers:</strong><br />
            LVM Versicherung<br />
            Westendstr. 195<br />
            80686 München
          </p>
          <p>
            <strong>Geltungsraum der Versicherung:</strong><br />
            Deutschland
          </p>

          <h2 style={h2Style}>Verbraucherstreitbeilegung/Universalschlichtungsstelle</h2>
          <p>
            Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
            Verbraucherschlichtungsstelle teilzunehmen.
          </p>
        </div>
      </div>
    </div>
  );
}

const h2Style: React.CSSProperties = {
  fontSize: '1.125rem',
  fontWeight: 700,
  marginTop: '2rem',
  marginBottom: '0.5rem',
  color: '#1a1d21',
};